import TriDymeIcon from './img/TriDymeIcon.png';
// import EiffageIcon from './img/EiffageIcon.jpg';
// import Structure3DSvg from './img/Structure3D.svg';
import Structure3DSvg from './img/bridge.svg';
import ConcreteSectionSvg from './img/ConcreteSection.svg';
import SteelSectionSvg from './img/SteelSection.svg';
import SectionGeometrySvg from './img/SectionGeometry.svg';
// import StructuralAnalysisSvg from './img/StructuralAnalysis1.svg';
import WaveCharacteristicsSvg from './img/WaveCharacteristics.svg';
import RegressionSvg from './img/Regression.svg';
import BIMViewerSvg from './img/BimViewer.svg';
import DatBimIconPng from './img/DatBimIcon.png';
import DevKitWebAppSvg from './img/DevKitWebApp.svg';
import ArchicadIconPng from './img/ArchicadIcon.png';
import RevitIconJpg from './img/RevitIcon.jpg';

const {
  REACT_APP_URL
} = process.env;

const features = {
  plugins: {
    categoriesList: [
      { label: 'Architecture', value: 'Architecture' },
    ],
    applicationsList: [
      {
        imgsrc: ArchicadIconPng,
        title: 'tridymearchicad.title',
        group: 'tridymearchicad.group',
        category: 'Architecture',
        description: 'tridymearchicad.description',
        link: '',
        href: '',
        status: 'Coming Soon',
        tags: ['tag.bim', 'tag.plugin', 'tag.archicad'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      {
        imgsrc: RevitIconJpg,
        title: 'tridymerevit.title',
        group: 'tridymerevit.group',
        category: 'Architecture',
        description: 'tridymerevit.description',
        link: '',
        href: '',
        status: 'Coming Soon',
        tags: ['tag.bim', 'tag.plugin', 'tag.revit'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      }
    ]
  },
  applications: {
    categoriesList: [
      { label: 'Structure', value: 'Structure' },
      // { label: 'Environnement', value: 'Environmental Loads' },
      { label: 'Intelligence Artificelle', value: 'AI' },
      { label: 'BIM', value: 'BIM' },
      { label: 'Developpement', value: 'Dev' },
      { label: 'Impression 3D', value: '3D Printing' }
    ],
    applicationsList: [
      {
        imgsrc: Structure3DSvg,
        title: 'structure3d.title',
        group: 'structure3d.group',
        category: 'Structure',
        description: 'structure3d.description',
        link: '/structure3d',
        href: `${REACT_APP_URL}/structure3d`,
        status: 'Beta',
        tags: ['tag.structure', 'tag.3d', 'tag.cloud'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: 'https://www.youtube.com/watch?v=dEpGTg1ZSjU&list=PLnyZofGl5v2aDpxV0t7ks6T8oOAAEOUEn'
      },
      {
        imgsrc: SteelSectionSvg,
        title: 'steelsection.title',
        group: 'steelsection.group',
        category: 'Structure',
        description: 'steelsection.description',
        link: '/steelsection',
        href: `${REACT_APP_URL}/steelsection`,
        status: 'Beta',
        tags: ['tag.structure', 'tag.steel'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      {
        imgsrc: ConcreteSectionSvg,
        title: 'concretesection.title',
        group: 'concretesection.group',
        category: 'Structure',
        description: 'concretesection.description',
        link: '/concretesection',
        href: `${REACT_APP_URL}/concretesection`,
        status: 'Beta',
        tags: ['tag.structure', 'tag.concrete', 'tag.cloud'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      {
        imgsrc: SectionGeometrySvg,
        title: 'sectiongeometry.title',
        group: 'sectiongeometry.group',
        category: 'Structure',
        description: 'sectiongeometry.description',
        link: '/sectiongeometry',
        href: `${REACT_APP_URL}/sectiongeometry`,
        status: 'New',
        tags: ['tag.structure', 'tag.geometry'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      // {
      //   imgsrc: StructuralAnalysisSvg,
      //   title: 'Structural Analysis',
      //   category: 'Structure',
      //   description: 'Structural Analysis allows you to get reactions, moments and deflections for simple structure',
      //   link: '/structuralanalysis/beamformulas',
      //   status: 'New',
      //   tags: ['#structure'],
      //   logoCompany: TriDymeIcon,
      //   company: 'TriDyme',
      //   video: ''
      // },
      {
        imgsrc: WaveCharacteristicsSvg,
        title: 'wavecharacteristics.title',
        group: 'wavecharacteristics.group',
        category: 'Hydraulic',
        description: 'wavecharacteristics.description',
        link: '/wavecharacteristics',
        href: `${REACT_APP_URL}/wavecharacteristics`,
        status: 'New',
        tags: ['tag.hydraulic', 'tag.wave'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      // {
      //   imgsrc: RegressionSvg,
      //   title: 'Regression',
      //   category: 'AI',
      //   description: 'Regression is the task of approximating a mapping function (f) from input variables (X) to a continuous output variable (y)',
      //   // link: '/regression',
      //   status: 'Coming Soon',
      //   tags: ['#ia'],
      //   logoCompany: TriDymeIcon,
      //   company: 'TriDyme',
      //   video: ''
      // },
      {
        imgsrc: BIMViewerSvg,
        title: 'bimviewer.title',
        group: 'bimviewer.group',
        category: 'BIM',
        description: 'bimviewer.description',
        link: '',
        // href: 'https://bim-viewer.herokuapp.com',
        status: 'Coming Soon',
        tags: ['tag.bim', 'tag.3d'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      },
      // {
      //   imgsrc: DatBimIconPng,
      //   title: 'Open - datBIM',
      //   category: 'BIM',
      //   description: 'Open-datBIM, la bibliothèque de contenus BIM de référence disponible directement en ligne',
      //   // link: '/datbim',
      //   href: '',
      //   status: 'Coming Soon',
      //   tags: ['#bim', '#database'],
      //   logoCompany: DatBimIconPng,
      //   company: 'datBim',
      //   video: ''
      // },
      {
        imgsrc: DevKitWebAppSvg,
        title: 'kitwebapp.title',
        group: 'kitwebapp.group',
        category: 'Dev',
        description: 'kitwebapp.description',
        link: '',
        href: 'https://gitlab.com/triazur/triazur-webapp-kit-serverless',
        status: 'Beta',
        tags: ['tag.dev', 'tag.webapp'],
        logoCompany: TriDymeIcon,
        company: 'TriDyme',
        video: ''
      }
    ]
  }
};

export default features;
